import * as Action from '../actions/index';
import { produce } from 'immer';
export const initialState = {
  backend: {
    productList: null,
    selectedProduct: null,
  },
  frontend: {
    selectedCategory: null,
    productList: null,
    menuCategories: null,
  },
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Action.CREATE_RESERVATION:
        break;
      case Action.GET_ALLRESERVATIONS:
        break;
      case Action.ADD_MENU_CATEGORIES:
        draft.frontend.menuCategories = action.payload.categories;
        break;
      case Action.ADD_MENU_PRODUCTS:
        draft.frontend.productList = action.payload;
        break;
      case Action.GET_ADMIN_PRODUCTS:
        draft.backend.productList = action.payload;
        break;
      case Action.DELETE_PRODUCT:
        const productId = action.payload;
        const productIndex = draft.backend.productList.findIndex(
          (el) => el.id === productId
        );
        draft.backend.productList.splice(productIndex, 1);
        break;
      case Action.SELECT_ADMIN_PRODUCT:
        draft.backend.selectedProduct = action.payload;
        break;
      default:
        break;
    }
  });
export default reducer;
